/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/require-default-props */
import React from 'react';
import { Card, TextStyle } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { CurrencyText } from '@nile/components';
import { FormattedMessage } from 'react-intl';

export type Unit = 'hours' | 'money' | 'percentage';

const ConsumptionBreakDownCard = ({
  title,
  icon,
  value,
  unit,
  loading
}: {
  title: string;
  icon: string;
  value: string | React.ReactNode;
  unit?: Unit;
  loading: boolean;
}) => {
  let valueText: React.ReactElement;

  switch (unit) {
    case 'money':
      valueText = <CurrencyText value={(value as string) || '0'} />;
      break;
    case 'percentage':
      valueText = <span>{(value as string) || '0'}%</span>;
      break;
    default:
      valueText = <span>{(value as string) || '0'}Hr</span>;
      break;
  }

  return (
    <div className="fg1">
      <Card
        border="secondary"
        padding="sizeSmall"
        hideOnPrint
        loading={loading}
      >
        <div className="w350 h180">
          <span className="fx actr fw h-40 g10">
            <SVGIcon name={icon || 'ChartModule'} size="xl" />
            <TextStyle variation="strong">
              <FormattedMessage id={title} />
            </TextStyle>
          </span>
          <div className="fx actr jctr fw ch-40 ellipsis">
            <div className="f-24 font-weight-600">{valueText}</div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ConsumptionBreakDownCard;
